import { render, staticRenderFns } from "./AddTweets.vue?vue&type=template&id=25bcc656&scoped=true&"
import script from "./AddTweets.vue?vue&type=script&lang=js&"
export * from "./AddTweets.vue?vue&type=script&lang=js&"
import style0 from "./AddTweets.vue?vue&type=style&index=0&id=25bcc656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bcc656",
  null
  
)

export default component.exports